import React from 'react';
import Button from '../../../components/base/Button';

export default function NewsSection() {
  const news = [
    {
      id: 1,
      category: '行业动态',
      title: '2025年碳中和政策解读：企业如何抓住绿色发展机遇',
      excerpt: '随着国家碳达峰碳中和目标的深入推进，新的政策法规为企业带来了前所未有的发展机遇。本文深入解析最新政策要点...',
      date: '2025-01-15',
      readTime: '5分钟阅读',
      image: '/src/assets/images/news-policy.jpg',
      tags: ['政策解读', '碳中和', '绿色发展']
    },
    {
      id: 2,
      category: '技术创新',
      title: '区块链技术在碳资产管理中的创新应用实践',
      excerpt: '探索区块链技术如何革命性地改变碳资产管理模式，提升交易透明度和可信度，为碳市场发展注入新动力...',
      date: '2025-01-12',
      readTime: '7分钟阅读',
      image: '/src/assets/images/news-blockchain.jpg',
      tags: ['区块链', '碳资产', '技术创新']
    },
    {
      id: 3,
      category: '案例分享',
      title: '某大型制造企业碳中和转型成功案例解析',
      excerpt: '深度分析一家大型制造企业如何通过系统性的碳减排策略，成功实现生产过程的绿色转型，为同行业提供宝贵经验...',
      date: '2025-01-10',
      readTime: '6分钟阅读',
      image: '/src/assets/images/news-manufacturing.jpg',
      tags: ['案例分析', '制造业', '转型成功']
    },
    {
      id: 4,
      category: '市场趋势',
      title: '全球碳市场发展趋势及投资机会分析',
      excerpt: '全面解析全球碳市场的最新发展动态，分析未来投资热点和商业机会，为投资者和企业决策提供参考...',
      date: '2025-01-08',
      readTime: '8分钟阅读',
      image: '/src/assets/images/news-market.jpg',
      tags: ['市场分析', '投资机会', '全球趋势']
    },
    {
      id: 5,
      category: '解决方案',
      title: '智慧城市低碳发展的综合解决方案探讨',
      excerpt: '探讨如何通过智慧城市建设实现城市低碳发展目标，分析技术路径和实施策略，为城市管理者提供决策支持...',
      date: '2025-01-05',
      readTime: '9分钟阅读',
      image: '/src/assets/images/news-smart-city.jpg',
      tags: ['智慧城市', '低碳发展', '解决方案']
    },
    {
      id: 6,
      category: '公司动态',
      title: '捷碳科技荣获"年度最佳低碳技术服务商"奖项',
      excerpt: '在2025年度低碳技术创新大会上，捷碳科技凭借在碳减排技术服务领域的卓越表现，荣获"年度最佳低碳技术服务商"殊荣...',
      date: '2025-01-03',
      readTime: '3分钟阅读',
      image: '/src/assets/images/news-award.jpg',
      tags: ['公司荣誉', '技术服务', '行业认可']
    }
  ];

  return (
    <section id="news" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-600 rounded-full text-sm font-medium mb-4">
            新闻动态
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            行业资讯与公司动态
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            及时了解低碳技术行业的最新发展动态，掌握前沿技术趋势和政策变化
          </p>
        </div>

        {/* Featured News */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Main Featured Article */}
          <div className="lg:col-span-1">
            <article className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 h-full">
              <div className="h-64 overflow-hidden">
                <img 
                  src={news[0].image}
                  alt={news[0].title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <span className="bg-emerald-100 text-emerald-600 px-3 py-1 rounded-full text-sm font-medium">
                    {news[0].category}
                  </span>
                  <span className="text-gray-400 text-sm ml-4">{news[0].date}</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 hover:text-emerald-600 transition-colors cursor-pointer">
                  {news[0].title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {news[0].excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex flex-wrap gap-2">
                    {news[0].tags.map((tag, index) => (
                      <span key={index} className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                        #{tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-sm text-gray-500">{news[0].readTime}</span>
                </div>
              </div>
            </article>
          </div>

          {/* Secondary Featured Articles */}
          <div className="space-y-6">
            {news.slice(1, 3).map((article) => (
              <article key={article.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="flex">
                  <div className="w-32 h-32 flex-shrink-0">
                    <img 
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-6 flex-1">
                    <div className="flex items-center mb-2">
                      <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs font-medium">
                        {article.category}
                      </span>
                      <span className="text-gray-400 text-xs ml-2">{article.date}</span>
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2 hover:text-emerald-600 transition-colors cursor-pointer line-clamp-2">
                      {article.title}
                    </h4>
                    <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <span className="text-xs text-gray-500">{article.readTime}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {news.slice(3).map((article) => (
            <article key={article.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group">
              <div className="h-48 overflow-hidden">
                <img 
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="bg-purple-100 text-purple-600 px-3 py-1 rounded-full text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-gray-400 text-xs ml-3">{article.date}</span>
                </div>
                <h4 className="font-bold text-gray-900 mb-3 hover:text-emerald-600 transition-colors cursor-pointer">
                  {article.title}
                </h4>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex flex-wrap gap-1">
                    {article.tags.slice(0, 2).map((tag, index) => (
                      <span key={index} className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                        #{tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">{article.readTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => window.REACT_APP_NAVIGATE('/news')}
          >
            <i className="ri-article-line mr-2"></i>
            查看更多资讯
          </Button>
        </div>
      </div>
    </section>
  );
}
